<mat-sidenav-container style="height: 100%">
  <mat-sidenav disableClose opened mode="side">
    <pl-sidenav></pl-sidenav>
  </mat-sidenav>
  <mat-sidenav-content class="d-flex flex-column pb-5">
    <pl-header style="flex: none"></pl-header>
    <div *ngIf="layout?.title" class="title-bar pt-2 pt-md-4 px-2 px-md-4">
      <div class="mb-3 d-flex align-items-center">
        <h1 class="title">{{ layout?.title }}</h1>
      </div>
    </div>
    <div style="flex: 1 1 auto">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
